import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_ITEMS } from "@/data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
            <img src={BRAND.logo} alt={BRAND.name} className="h-10 w-10 lg:h-12 lg:w-12 object-contain" />
            <span className="font-heading font-bold text-lg lg:text-xl text-slate-900 leading-none">
              Impulsion<span className="text-green-600"> Locale</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className={`text-sm font-semibold transition-colors hover:text-green-600 ${
                  location.pathname === item.path ? "text-green-600" : "text-slate-700"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <button
              data-testid="navbar-cta-button"
              onClick={() => navigate("/diagnostic")}
              className="bg-green-600 hover:bg-green-700 text-white rounded-xl px-5 py-2.5 text-sm font-semibold transition-colors shadow-sm"
            >
              Diagnostic gratuit
            </button>
          </nav>

          <button
            data-testid="navbar-mobile-toggle"
            className="md:hidden p-2 text-slate-900"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-slate-100 shadow-lg">
          <nav className="flex flex-col px-4 py-4 gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className="px-3 py-3 rounded-lg text-base font-semibold text-slate-800 hover:bg-slate-50"
              >
                {item.label}
              </Link>
            ))}
            <button
              data-testid="mobile-cta-button"
              onClick={() => navigate("/diagnostic")}
              className="mt-2 bg-green-600 hover:bg-green-700 text-white rounded-xl px-5 py-3 text-base font-semibold"
            >
              Faire le diagnostic gratuit
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
